export default __webpack_public_path__ + "static/media/swissmarketsReal_downloadMT4.286d1e2d.png";